export default __webpack_public_path__ + "static/media/filgreen4.00f2f823.png";